import "./HtmlEmbed.style.scss";
import { replaceImgWithAmpImg } from "../lib/image";
import type { HtmlProps } from "../lib/embed";

export const HtmlEmbed = ({ amp, value }: HtmlProps) => {
    if (!value) {
        return null;
    }

    if (amp && value.includes("<img")) {
        value = replaceImgWithAmpImg(value);
    }

    return <div className="component-embed-html" dangerouslySetInnerHTML={{ __html: value }} />;
};

export default HtmlEmbed;
